// extracted by mini-css-extract-plugin
export var container = "youtube_section-module--container--5455b";
export var steam_iframe = "youtube_section-module--steam_iframe--0d5ab";
export var steam_widget = "youtube_section-module--steam_widget--78b32";
export var youtube_iframe = "youtube_section-module--youtube_iframe--174de";